var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "signup" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12 col-md-6 bordered" }, [
          _c("div", { staticClass: "box" }, [
            _c("div", {
              staticClass: "singup-page-content",
              domProps: { innerHTML: _vm._s(_vm.content) },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-md-6" },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm.userLoggedIn
              ? [
                  _c("FormResult", {
                    attrs: {
                      "message-type": "none",
                      "reset-button": false,
                      "message-h1": "Oops!",
                      "message-p":
                        "You are already logged in. If you want to sign up another account please log out first.",
                    },
                  }),
                ]
              : [
                  !_vm.signed
                    ? [_c("signup-form", { attrs: { links: _vm.links } })]
                    : _vm.signed === "success"
                    ? [
                        _c("FormResult", {
                          attrs: {
                            "message-type": _vm.signed,
                            "reset-button": false,
                            "message-h1": "Great!",
                            "message-p":
                              "Thank you. We have sent you an email with a link to activate your new account.",
                          },
                        }),
                      ]
                    : _vm.signed === "error"
                    ? [
                        _c("FormResult", {
                          attrs: {
                            "message-type": _vm.signed,
                            "reset-button": true,
                            "message-h1": "Oops!",
                            "message-p":
                              "Sorry, we could not create your account.",
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "signup-header" }, [
      _c("h2", [_vm._v("Create an Account")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }